<template>
  <div>
    <div class="week_box">
      <el-calendar v-model="value" id="calendar">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{ date, data }">
          <!--自定义内容-->
          <div class="calendar-day">
            <span>{{ data.day.split("-").slice(2).join("-")}}</span>
            <p v-for="(items, index) in timel" v-if="timel[index].day == data.day.split('-').slice(2).join('-')&&timel[index].month == data.day.split('-')[1]" class="of1" :alt="items.Title">
              <strong>·</strong>{{items.Title}}
            </p>
          </div>
        </template>
      </el-calendar>
    </div>
  </div>
</template>
<script>
  export default {
    name: "calendar",
    data() {
      return {
        timel: [],
        timeTitle: "",
        value: new Date().getTime(),
        book_list_t: true,
        TaskCenterL: [],
        DateTime: ""
      };
    },
    created() {
      this.tokenkey = this.$cookies.get("token");
      let myDate = new Date();
      let year = myDate.getFullYear();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      let firstDay = month + "/" + "01/" + year;
      myDate = new Date(year, month, 0);
      let lastDay = month + "/" + myDate.getDate() + "/" + year;
      this.TaskCenterS2(firstDay, lastDay);
      this.ServerDateTime();
    },
    methods: {
      // 系统时间
      ServerDateTime() {
        let that = this;
        this.$http
          .get("https://schoolapi.eiceducation.com.cn/api/ServerDateTime")
          .then(function(result) {
            let resultsT = new Date(
              result.data.results.replace("-", "/").replace("-", "/")
            );
            that.DateTime = parseInt(resultsT.getTime() / 1000);
            // // console.log(that.DateTime)
          })
          .catch(function(error) {
            // console.log(error);
            that.$message.error(error);
          });
      },
      TaskCenterS2(firstDay, lastDay) {
        this.timel = [];
        let that = this;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/TaskCenter?beginTime=" +
            firstDay +
            "&endTime=" +
            lastDay, {
              headers: {
                token: that.tokenkey
              }
            }
          )
          .then(function(result) {
            // // console.log(result)
            if (result.data.count > 0) {
              let ary = [];
              for (let item of result.data.results) {
                // console.log(item);
                let obj = {
                  day: Number(item.EndTime.slice(8, 10)),
                  month: Number(item.EndTime.slice(6,7)),
                  ...item
                }
                ary.push(obj);
              }
              that.timel = ary;
              console.log(ary, "ary")
            } else {
              that.timel = [];
            }
          })
          .catch(function(error) {
            // console.log(error);
            that.$message.error(error);
          });
        this.$nextTick(() => {
          // 点击上个月
          let prevBtn1 = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(1)"
          );
          prevBtn1.onclick = () => {
            // let myDate = new Date(this.value.replace("-", "/").replace("-", "/"));
            let myDate = new Date(this.value);
            let year = myDate.getFullYear();
            let month = myDate.getMonth() + 1;
            if (month < 10) {
              month = "0" + month;
            }
            let firstDay = month + "/" + "01/" + year;
            myDate = new Date(year, month, 0);
            let lastDay = month + "/" + myDate.getDate() + "/" + year;
            this.TaskCenterS2(firstDay, lastDay);
          };
          // 点击今天
          let prevBtn2 = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(2)"
          );
          prevBtn2.onclick = () => {
            // let myDate = new Date(this.value.replace("-", "/").replace("-", "/"));
            let myDate = new Date(this.value);
            let year = myDate.getFullYear();
            let month = myDate.getMonth() + 1;
            if (month < 10) {
              month = "0" + month;
            }
            let day = myDate.getDate();
            let firstDay = month + "/" + "01/" + year;
            myDate = new Date(year, month, 0);
            let lastDay = month + "/" + myDate.getDate() + "/" + year;
            this.TaskCenterS2(firstDay, lastDay);
          };
          // 点击下个月
          let prevBtn3 = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(3)"
          );
          prevBtn3.onclick = () => {
            // let myDate = new Date(this.value.replace("-", "/").replace("-", "/"));
            let myDate = new Date(this.value);
            let year = myDate.getFullYear();
            let month = myDate.getMonth() + 1;
            if (month < 10) {
              month = "0" + month;
            }
            let firstDay = month + "/" + "01/" + year;
            myDate = new Date(year, month, 0);
            let lastDay = month + "/" + myDate.getDate() + "/" + year;
            this.TaskCenterS2(firstDay, lastDay);
          };
        });
      },
      // 进入直播间
      studio(roomid, contentType, contentId) {
        let that = this;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/BJYSign?contentType=" +
            contentType +
            "&contentId=" +
            contentId +
            "&roomid=" +
            roomid, {
              headers: {
                token: that.tokenkey
              }
            }
          )
          .then(function(result) {
            // // console.log(result)
            let room_id = roomid; //房间号
            let user_number = that.$parent.Number; //用户数字ID
            let user_role = 0; //用户身份0:学生 1:老师 2:管理员
            let user_name = that.$parent.NickName; //用户名
            let user_avatar = that.$parent.HeadUrl; //用户头像
            let sign = result.data.results; //用户签名
            let web_url =
              "https://b96135432.at.baijiayun.com/web/room/enter?room_id=" +
              roomid +
              "&user_number=" +
              user_number +
              "&user_role=" +
              user_role +
              "&user_name=" +
              user_name +
              "&user_avatar=" +
              user_avatar +
              "&sign=" +
              sign;
            window.open(web_url);
          })
          .catch(function(error) {
            // console.log(error);
            that.$message.error(error);
          });
      }
    }
  };
</script>
<style scoped>
  @import url("./xxcalendar.css");
</style>



// WEBPACK FOOTER //
// src/page/xxcalendar/xxcalendar.vue